const addNewRecipe = (recipe) => {
    return {
        type: 'ADD_NEW_RECIPE',
        payload: recipe
    }
};

const editRecipe = (index, recipe) => {
    return {
        type: 'EDIT_RECIPE',
        payload: {
            index: index,
            recipe: recipe
        }
    }
};

const updateImage = (index, image) => {
    return {
        type: 'UPDATE_IMAGE',
        payload: {
            index: index,
            image: image
        }
    }
};

const removeRecipe = (index) => {
    return {
        type: 'REMOVE_RECIPE',
        payload: index
    }
};

const updateFavorite = (index, favorite) => {
    return {
        type: 'UPDATE_FAVORITE',
        payload: {
            index: index,
            favorite: favorite
        }
    }
};

const clearData = () => {
    return {
        type: 'CLEAR_DATA'
    }
}

export { addNewRecipe, editRecipe, updateImage, removeRecipe, updateFavorite, clearData };